import clsx from 'clsx';

import Email from '../assets/svgs/email.svg';
import Location from '../assets/svgs/location.svg';
import Phone from '../assets/svgs/phone.svg';

import { SocialMedia } from './SocialMedia';

const Contact = () => {
	return (
		<div className='w-[300px]'>
			<p className='my-1 text-lg'>
				<img
					src={Phone}
					alt=''
					width={16}
					height={16}
					className='mr-2 inline h-4 w-4 opacity-80'
				/>
				<span className='text-[#c2ccdd]'>+966 563578523 </span>
			</p>

			<p className='my-1 text-lg'>
				<img
					src={Email}
					alt=''
					width={16}
					height={16}
					className='mr-2 inline h-4 w-4 opacity-80'
				/>
				<span className='text-[#c2ccdd]'>info@SawaedCo.com</span>
			</p>
			{/* <hr className='my-4 border-b border-[#c2ccdd]' /> */}
			<p className='my-1 text-lg'>
				<img
					src={Location}
					alt=''
					width={16}
					height={16}
					className='mr-2 inline h-4 w-4 opacity-80'
				/>
				<span className='text-[#c2ccdd]'>الرياض - حي المربع - شارع الوشم</span>
			</p>
			{/* <p className='my-1 text-lg'>
				<img
					src={Location}
					alt=''
					width={16}
					height={16}
					className='mr-2 inline h-4 w-4 opacity-80'
				/>
				<span className='text-[#c2ccdd]'>
					Riyadh - Al Murabba' District Al-Washem St.
				</span>
			</p> */}
		</div>
	);
};

function Footer(props) {
	const { hasBackground = false } = props;

	return (
		<footer
			className={clsx(
				hasBackground ? 'bg-secondary-700' : '',
				'!w-screen p-14'
			)}>
			<div className='flex flex-row-reverse items-center justify-between gap-4'>
				<SocialMedia />
				<div>
					<p className='text-[#c2ccdd]'>© 2024 Sawaed. All rights reserved.</p>
				</div>
			</div>
			<hr className='my-6 border-b border-[#c2ccdd]' />
			<div className='flex h-full w-full flex-col justify-between gap-6 md:flex-row md:gap-32'>
				<div className='flex flex-1 flex-col'>
					<em className='mb-0 text-[#c2ccdd]'>
						Construction and trading made better...
					</em>
					<p className='mt-3 text-[#c2ccdd]'>
						Sawaed is dedicated to elevating the construction industry by
						delivering exceptional service, fostering innovation, and building a
						community of excellence. Our commitment to quality and on-time
						delivery ensures that every project we undertake meets the highest
						standards, uniting all stakeholders in a shared vision for success.
					</p>
				</div>
				<div className='min-w-[10%]'>
					<Contact />
				</div>
			</div>
		</footer>
	);
}
export default Footer;
